import { Box, Card, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import styles from "../devoteeService.module.scss";
import { useEffect, useRef, useState } from "react";
import { object, string, ValidationError } from "yup";
import {
  CustomRequiredInputLabel,
  CustomTextFeild,
  CommonButton,
  ContactNumberInput,
} from "../../common/StyledComponents/StyledFields";
import constants from "../../../config/constants.json";
import { identity, isEmpty, isNil, pickBy } from "lodash";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import toast from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import Pagination from "../../common/pagination/pagination";
import ErrorPopup from "../../common/ErrorPopup";
import { displayPhoneNumberFormattoPlain } from "../../common/phoneNumberFormats/phoneNumberFormats";
import CloseIcon from "@mui/icons-material/Close";
import ToastComponent from "../../common/toastComponent";
import { title } from "process";
import { BounceLoader } from "react-spinners";

interface serachDevoteeProps {
  setShowSearchDevotee: React.Dispatch<React.SetStateAction<boolean>>;
}
interface ErrorMessageTypes {
  signinName: string;
  firstName: string;
  lastName: string;
  city: string;
  state: string;
  phonenumber: string;
  email: string;
  zipcode: string;
}

const SearchDevotee = (props: serachDevoteeProps) => {
  const [loading, setLoading] = useState(false);
  const [loadingBounce, setLoadingBounce] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [searchItems, setSearchItem] = useState([]);
  const [searchButton, setSearchButton] = useState<boolean>(true);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [showdevoteeTable, setShowdevoteeTable] = useState<boolean>(false);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [openUserDetailsDialog, setOpenUserDetailsDialog] = useState(false);
  const [userDetailsList, setUserDetailsList] = useState<any>({});
  const [userDetailsDevoteeCategoryList, setUserDetailsDevoteeCategoryList] = useState<any>([]);
  const [formData, setFormData] = useState({
    signinName: "",
    firstName: "",
    lastName: "",
    phonenumber: "",
    email: "",
    city: "",
    state: "",
    zipcode: "",
  });
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    signinName: "",
    firstName: "",
    lastName: "",
    phonenumber: "",
    email: "",
    city: "",
    state: "",
    zipcode: "",
  });

  const [pageSize, setPageSize] = useState<number>(20);

  const prevPageNumber = usePrevious(pageNumber);

  function usePrevious(value: any) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current; // Return previous value (before update)
  }

  useEffect(() => {
    // Check if previous values are not undefined to ensure this is not the first render
    // And then check if the current values differ from the previous ones
    if ((prevPageNumber !== undefined && prevPageNumber !== pageNumber)) {
      searchDataApi();
    }
  }, [pageNumber, prevPageNumber, pageSize]);


  const validationSchema = object().shape({
    // signinName: string().required("Sign name is required"),
    // firstName: string().required("First Name is required"),
    // lastName: string().required("Last Name is required"),
    // email: string()
    //   .email("Invalid email address")
    //   .required("Email is required"),
    // phonenumber: string().required("Phone Number is required"),
    // city: string().required("City is required"),
    // state: string().required("State is required"),
    // zipcode: string().required("Zipcode is required"),
  });
  const handleSearch = async () => {
    const errors: ErrorMessageTypes = {
      signinName: "",
      firstName: "",
      lastName: "",
      phonenumber: "",
      email: "",
      city: "",
      state: "",
      zipcode: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);

      // Call your API or perform other actions here
      searchDataApi();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const handleKeyDownuser = (e: any, fieldName: string) => {
    if (!/[0-9a-zA-Z_]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const searchDataApi = () => {
    const reqBody = {
      firstname: formData.firstName,
      lastname: formData.lastName,
      email: formData.email,
      username: formData.signinName,
      city: formData.city,
      state: formData.state,
      zipcode: formData.zipcode,
      sortBy: formData.signinName,
      // phoneNumber: displayPhoneNumberFormattoPlain(formData.phonenumber).length === 10 ? displayPhoneNumberFormattoPlain(formData.phonenumber) : displayPhoneNumberFormattoPlain(formData.phonenumber).substring(1),
      phoneNumber: formData.phonenumber,
      matchOperator: "AND"
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.serachDevoteeApi,
      body: JSON.stringify(reqBody),
      includeToken: true,
      params: {
        sortBy: formData.signinName,
        page: pageNumber - 1,
        size: 20,
        direction: "asc",
      },
    })
      .then((res) => {
        setLoading(false);
        setTotalRecords(res.data.totalElements);
        setShowdevoteeTable(true);

        if (res.data.content.length === 0) {
          setSearchItem([]);
        } else {
          setSearchItem(res.data.content);
          setErrorMessage({ ...errorMessage, signinName: "" });
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };
  const zipCodeApi = () => {
    if (formData.zipcode !== "") {
      apiRequest({
        method: "GET",
        endpoint: apiPath.cityAndStateApi,
        params: {
          zip: formData.zipcode,
        },
      })
        .then((res) => {
          setErrorMessage({
            ...errorMessage,
            zipcode: "",
          });
          setFormData({
            ...formData,
            state: res.data.stateName,
            city: res.data.city,
          });
        })
        .catch((err) => {
          console.log(err);

          setErrorMessage({
            ...errorMessage,
            zipcode: catchErrorMessageHandler(err),
          });
          setFormData({
            ...formData,
            state: "",
            city: "",
          });
        });
    }
  };

  useEffect(() => {
    if (!isEmpty(pickBy(errorMessage, identity))) {
      setSearchButton(true);
    } else if (
      formData.phonenumber !== "" &&
      displayPhoneNumberFormattoPlain(formData.phonenumber) === ""
    ) {
      setSearchButton(true);
    } else if (!isEmpty(pickBy(formData, identity))) {
      setSearchButton(false);
    } else {
      setSearchButton(true);
    }
  }, [formData]);

  useEffect(() => {
    setFormData({ ...formData, city: "", state: "" })
  }, [formData.zipcode])


  const handleFieldChange = (field: string, value: any) => {
    if (formData.signinName || formData.firstName || formData.lastName) {
      setSearchButton(false);
    } else {
      setSearchButton(true);
    }
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleKeyDown = (e: any, fieldName: string) => {
    // Prevent entering numeric characters, spaces, and specific special characters
    if (
      (e.key >= "0" && e.key <= "9") ||
      e.key === " " || // prevent spaces
      /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-=`|"\s]/.test(e.key) // prevent specific special characters and whitespace
    ) {
      e.preventDefault();
    }
  };

  const userDetailsApiCall = (row: any) => {
    setLoadingBounce(true);
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.devoteeServiceUserDetailsApi}/${row.username}`,
      includeToken: true,
    })
      .then((res) => {
        setUserDetailsList(res?.data);
        setUserDetailsDevoteeCategoryList(res?.data?.categoryNames)
        setLoadingBounce(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingBounce(false);
      });
  };

  const handleSignInNameClick = (row: any) => {
    sessionStorage.setItem("devoteeID", row.username);
    sessionStorage.setItem("devoteeFullname", `${row.firstname} ${row.lastname}`);
    sessionStorage.setItem('devoteeDob', row.dateOfBirth ? row.dateOfBirth : '');
    sessionStorage.setItem('planguage', row.preferredLanguage ? row.preferredLanguage : '');
    sessionStorage.setItem('nakshatram', row.nakshatram ? row.nakshatram : '');
    sessionStorage.setItem('gothram', row.gothram ? row.gothram : '');
    sessionStorage.setItem('address', row.address ? row.address : '');
    sessionStorage.setItem('city', row.city ? row.city : '');
    sessionStorage.setItem('state', row.state ? row.state : '');
    sessionStorage.setItem('zipcode', row.zipcode ? row.zipcode : '');
    sessionStorage.setItem('country', row.country ? row.country : '');
    sessionStorage.setItem('home', row.phoneResidence ? row.phoneResidence : '');
    sessionStorage.setItem('work', row.phoneWork ? row.phoneWork : '');
    sessionStorage.setItem('updatedate', row.updateDate ? row.updateDate  : '');
    sessionStorage.setItem('registratiion', row.dateOfRegistration ? row.dateOfRegistration : '');
    sessionStorage.setItem('email', row.email ? row.email : '');
    sessionStorage.setItem('access', row.enableAccess ?  "Enable" : 'Disable')
    props.setShowSearchDevotee(false);
  };

  const handleDetailsClick = (row: any) => {
    setSelectedUserName(row.username);
    setOpenUserDetailsDialog(true);
    userDetailsApiCall(row);
  }

  const listItemTable = () => {
    if (searchItems.length === 0) {
      return <Typography sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}><b>{constants.NO_RECORDS_FOUND}</b></Typography>;
    }
    return (
      <>
        <div style={{ overflowY: "auto" }}>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Sign-In Name</th>
                <th className={styles.tableHorizontal}>Name</th>
                <th className={styles.tableHorizontal}>Address</th>
                <th className={styles.tableHorizontal}>Email</th>
                <th className={styles.tableHorizontal}>PhoneNo</th>
                <th className={styles.tableHorizontal}>Details</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody} id="searchData" >
              {searchItems.map((row: any, id: number) => (
                <tr key={id} className={styles.tableRow}>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() => handleSignInNameClick(row)}
                  >
                    {row.username}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {`${row.firstname} ${row.lastname}`}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {getDevoteeAddress(row, false)}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.email}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.phoneWork}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "center",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() => handleDetailsClick(row)}
                  >
                    <p>Details</p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {totalRecords > 20 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: "10px",
                marginTop: "3px",
              }}
            >
              <Pagination
                items={totalRecords}
                itemsPerPage={20}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
              />
            </div>
          ) : (
            ""
          )}
        </div>

      </>
    );
  };

  const handleUserDetailsDialogClose = () => {
    setOpenUserDetailsDialog(false);
  };

  const getDevoteeAddress = (data: any, details=true) => {
    const { state, city, address, zipcode, country } = data;
    return [address, city, `${state}${zipcode ? `${details ? " - ": ""} ${zipcode}` : " "}`, `${details ? country: ""}`]
      ?.filter(Boolean)
      ?.join(", ");
  };

  const userDetailsTableComponent = () => {
    const categories = Array.isArray(userDetailsDevoteeCategoryList) ? userDetailsDevoteeCategoryList : [];

    // Map categories to JSX elements with <br/> separators
    const categoriesWithLineBreaks = categories.map((category, index) => (
      <div key={index}>
        {category}{index < categories.length - 1 && <br />}
      </div>
    ));

    return (
      <Grid>
        {/* {userDetailsList?.map((user: any, index: any) => ( */}
        <table className={styles.tableDetailsTableContainer}>
          <tbody>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Sign-in Name</td>
              <td className={styles.contentTableColumn}>{userDetailsList.username}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Name</td>
              <td className={styles.contentTableColumn}>{`${userDetailsList.firstName} ${userDetailsList.middleName ? userDetailsList.middleName + ' ' : ''} ${userDetailsList.lastName}`} </td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Address</td>
              <td className={styles.contentTableColumn}>
                {getDevoteeAddress(userDetailsList)}
              </td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Home Phone</td>
              <td className={styles.contentTableColumn}>{userDetailsList.phoneResidence === null || userDetailsList.phoneResidence === "" ? "-" : userDetailsList.phoneResidence}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Work Phone</td>
              <td className={styles.contentTableColumn}>{userDetailsList.phoneWork === null || userDetailsList.phoneWork === "" ? "-" : userDetailsList.phoneWork}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Email</td>
              <td className={styles.contentTableColumn}>{userDetailsList.email === null || userDetailsList.email === "" ? "-" : userDetailsList.email}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Category</td>
              <td className={styles.contentTableColumn}><span style={{ fontWeight: 600 }}>{userDetailsList.defaultCategoryName}</span><br />
                {categoriesWithLineBreaks}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Date of Registration</td>
              <td className={styles.contentTableColumn}>{userDetailsList.dateOfRegistration === null || userDetailsList.dateOfRegistration === "" ? "-" : userDetailsList.dateOfRegistration}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Update Date</td>
              <td className={styles.contentTableColumn}>{userDetailsList.updateDate === null || userDetailsList.updateDate === "" ? "-" : userDetailsList.updateDate}</td>
            </tr>
          </tbody>
        </table>
        {/* ))} */}
      </Grid>
    );
  };

  const userDetailsDialogComponent = () => {
    return (
      <>
        <Dialog
          open={openUserDetailsDialog}
          onClose={handleUserDetailsDialogClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
              width: "600px",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"Devotee Details"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleUserDetailsDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            {/* {userDetailsTableComponent()} */}
            {loadingBounce ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BounceLoader color="#22A699" loading={loadingBounce} size={45} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Please wait...
                </span>
              </div>
            ) : (
              <div>
                {userDetailsTableComponent()}
                {/* {donationSummeryList.length > 0 ? (
                  poojaDetailsComponent()
                ) : (
                  <Typography sx={{ textAlign: "center" }}>No Data</Typography>
                )} */}
              </div>
            )}
          </DialogContent>
        </Dialog>
      </>
    )
  }

  return (
    <form className={styles.SearchContainer} autoComplete="off" onSubmit={handleSearch}>
      <ToastComponent />
      {userDetailsDialogComponent()}
      <Typography component="div" className={styles.typoGraphyHeading}>
        Devotee Service
      </Typography>
      <Typography component="div" className={styles.typoGraphy}>
        Search Devotee
      </Typography>
      <Box className={styles.formContainer} >
        <Card className={styles.cardContainer}>
          <div style={{ padding: "24px" }}>
            <Grid container spacing={2}>
              <Grid xs={12} sm={4} item>
                {CustomRequiredInputLabel("Sign-In Name", false)}
                <CustomTextFeild
                  id="signInName"
                  fullWidth
                  required
                  value={formData.signinName}
                  onChange={(e) => {
                    handleFieldChange("signinName", e.target.value);
                    setErrorMessage({ ...errorMessage, signinName: "" });
                  }}
                  className={
                    errorMessage.signinName
                      ? styles.errorTextField
                      : styles.textField
                  }
                  onBlur={() => {
                    const inputUserName = formData.signinName.toUpperCase();
                    handleFieldChange('signinName', inputUserName);
                  }}
                  onKeyDown={(e) => handleKeyDownuser(e, "signinName")}
                />
                {errorMessage.signinName ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.signinName}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
              <Grid xs={12} sm={4} item>
                {CustomRequiredInputLabel("First Name", false)}
                <CustomTextFeild
                  id="firstName"
                  fullWidth
                  required
                  onChange={(e) => {
                    handleFieldChange("firstName", e.target.value);
                    setErrorMessage({ ...errorMessage, firstName: "" });
                  }}
                  onKeyDown={(e) => handleKeyDown(e, "firstName")}
                  className={
                    errorMessage.firstName
                      ? styles.errorTextField
                      : styles.textField
                  }
                />
                {errorMessage.firstName ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.firstName}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
              <Grid xs={12} sm={4} item>
                {CustomRequiredInputLabel("Last Name", false)}
                <CustomTextFeild
                  id="lastName"
                  fullWidth
                  required
                  onChange={(e) => {
                    handleFieldChange("lastName", e.target.value);
                    setErrorMessage({ ...errorMessage, lastName: "" });
                  }}
                  onKeyDown={(e) => handleKeyDown(e, "lastName")}
                  className={
                    errorMessage.lastName
                      ? styles.errorTextField
                      : styles.textField
                  }
                />
                {errorMessage.lastName ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.lastName}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: "0px" }}>
              <Grid xs={12} sm={4} item>
                {CustomRequiredInputLabel("Zip Code", false)}
                <CustomTextFeild
                  id="zipCode"
                  fullWidth
                  required
                  onChange={(e) => {
                    handleFieldChange("zipcode", e.target.value);
                    setErrorMessage({ ...errorMessage, zipcode: "" });
                  }}
                  onBlur={zipCodeApi}
                  className={
                    errorMessage.zipcode
                      ? styles.errorTextField
                      : styles.textField
                  }
                />
                {errorMessage.zipcode ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.zipcode}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
              <Grid xs={12} sm={4} item>
                {CustomRequiredInputLabel("City", false)}
                <CustomTextFeild
                  id="city"
                  fullWidth
                  required
                  onChange={(e) => {
                    handleFieldChange("city", e.target.value);
                    setErrorMessage({ ...errorMessage, city: "" });
                  }}
                  value={formData.city}
                  InputProps={{
                    readOnly: true,
                  }}
                  className={
                    errorMessage.city ? styles.errorTextField : styles.textField
                  }
                />
                {errorMessage.city ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.city}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
              <Grid xs={12} sm={4} item>
                {CustomRequiredInputLabel("State", false)}
                <CustomTextFeild
                  id="state"
                  fullWidth
                  required
                  onChange={(e) => {
                    handleFieldChange("state", e.target.value);
                    setErrorMessage({ ...errorMessage, state: "" });
                  }}
                  value={formData.state}
                  InputProps={{
                    readOnly: true,
                  }}
                  className={
                    errorMessage.state
                      ? styles.errorTextField
                      : styles.textField
                  }
                />
                {errorMessage.state ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.state}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: "0px" }}>
              <Grid xs={12} sm={4} item>
                {CustomRequiredInputLabel("Phone Number", false)}
                <CustomTextFeild
                  id="phoneNumber"
                  fullWidth
                  value={formData.phonenumber}
                  onChange={(e) => {
                    const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                    const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                    handleFieldChange("phonenumber", slicedNumber);
                    setErrorMessage({ ...errorMessage, phonenumber: "" });
                  }}
                  className={
                    errorMessage.phonenumber
                      ? styles.errorTextField
                      : styles.textField
                  }
                />
                {errorMessage.phonenumber ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.phonenumber}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
              <Grid xs={12} sm={4} item>
                {CustomRequiredInputLabel("Email ID", false)}
                <CustomTextFeild
                  id="email"
                  fullWidth
                  required
                  onChange={(e) => {
                    handleFieldChange("email", e.target.value);
                    setErrorMessage({ ...errorMessage, email: "" });
                  }}
                  className={
                    errorMessage.email
                      ? styles.errorTextField
                      : styles.textField
                  }
                />
                {errorMessage.email ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.email}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </div>
        </Card>
      </Box>
      <Box>
        <Grid xs={12} item>
          <CommonButton
            className={styles.search}
            onClick={handleSearch}
            disabled={searchButton || loading}
            id="search"
            type="submit"
          >
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Loading...
                </span>
              </>
            ) : (
              "Search"
            )}
          </CommonButton>
        </Grid>
      </Box>

      {showdevoteeTable || searchItems.length > 0 ? (
        <div style={{ marginTop: "24px" }}>{listItemTable()}</div>
      ) : (
        ""
      )}
    </form>
  );
};

export default SearchDevotee;
